(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["about-makers-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
    const setRawFeatures = (root) => {
      root.querySelectorAll('[data-about-maker-raw-features]').forEach((list) => {
        try {
          const data = JSON.parse(list.dataset.aboutMakerRawFeatures || '');
          const features = Array.isArray(data) ? data : data.features;
          if (!Array.isArray(features)) return;

          features.slice(0, 3).forEach((feature) => {
            const item = document.createElement('li');
            item.textContent = [feature.value, feature.label].filter(Boolean).join(' ');
            list.appendChild(item);
          });
        } catch (error) {
          console.error('Error parsing maker display features:', error);
        }
      });
    };

    const initializeCarousel = (root) => {
      if (root.dataset.aboutMakersReady === 'true') return;
      root.dataset.aboutMakersReady = 'true';

      const track = root.querySelector('[data-about-makers-track]');
      const originalCards = Array.from(root.querySelectorAll('[data-about-maker-card]'));
      const dots = Array.from(root.querySelectorAll('[data-about-maker-dot]'));
      if (!track || originalCards.length === 0) return;

      setRawFeatures(root);

      const cloneCard = (card) => {
        const clone = card.cloneNode(true);
        clone.dataset.aboutMakerClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button').forEach((element) => {
          element.tabIndex = -1;
        });
        return clone;
      };

      const leadingCards = document.createDocumentFragment();
      const trailingCards = document.createDocumentFragment();
      originalCards.forEach((card) => {
        leadingCards.appendChild(cloneCard(card));
        trailingCards.appendChild(cloneCard(card));
      });
      track.prepend(leadingCards);
      track.append(trailingCards);

      const cards = Array.from(track.querySelectorAll('[data-about-maker-card]'));
      const originalStartIndex = originalCards.length;
      let activeIndex = Math.min(Number(root.dataset.initialIndex || 0), originalCards.length - 1);
      let frameRequest = null;
      let isPointerDown = false;
      let isDragging = false;
      let pointerStart = 0;
      let scrollStart = 0;
      let rebaseTimer = null;

      const getCardLeft = (card) => card.offsetLeft - ((track.clientWidth - card.offsetWidth) / 2);

      const centerOriginalCard = (index, behavior = 'auto') => {
        const card = cards[originalStartIndex + index];
        if (!card) return;
        track.scrollTo({ left: getCardLeft(card), behavior });
      };

      const centerNearestCard = (index, behavior = 'smooth') => {
        const matchingCards = cards.filter((card) => Number(card.dataset.cardIndex) === index);
        if (matchingCards.length === 0) return;

        const nearestCard = matchingCards.reduce((nearest, card) => {
          const nearestDistance = Math.abs(getCardLeft(nearest) - track.scrollLeft);
          const cardDistance = Math.abs(getCardLeft(card) - track.scrollLeft);
          return cardDistance < nearestDistance ? card : nearest;
        });
        track.scrollTo({ left: getCardLeft(nearestCard), behavior });
      };

      const getClosestCardIndex = () => {
        const trackCenter = track.getBoundingClientRect().left + (track.clientWidth / 2);
        let closestIndex = 0;
        let closestDistance = Infinity;

        cards.forEach((card, index) => {
          const rect = card.getBoundingClientRect();
          const distance = Math.abs((rect.left + (rect.width / 2)) - trackCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        return closestIndex;
      };

      const updateState = () => {
        const closestIndex = getClosestCardIndex();

        activeIndex = Number(cards[closestIndex].dataset.cardIndex);
        cards.forEach((card, index) => {
          const distance = Math.min(Math.abs(index - closestIndex), 2);
          card.classList.toggle('is-centered', distance === 0);
          card.classList.remove(
            'about-makers-card--distance-0',
            'about-makers-card--distance-1',
            'about-makers-card--distance-2'
          );
          card.classList.add(`about-makers-card--distance-${distance}`);
        });

        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        frameRequest = null;
      };

      const rebaseIfNeeded = () => {
        if (isPointerDown || isDragging) return;

        const closestIndex = getClosestCardIndex();
        const setWidth = cards[originalStartIndex].offsetLeft - cards[0].offsetLeft;
        let rebasedLeft = null;

        if (closestIndex < originalStartIndex) {
          rebasedLeft = track.scrollLeft + setWidth;
        } else if (closestIndex >= originalStartIndex * 2) {
          rebasedLeft = track.scrollLeft - setWidth;
        }

        if (rebasedLeft === null) return;
        track.classList.add('is-rebasing');
        track.scrollTo({ left: rebasedLeft, behavior: 'auto' });
        window.requestAnimationFrame(() => {
          track.classList.remove('is-rebasing');
          requestStateUpdate();
        });
      };

      const requestStateUpdate = () => {
        if (frameRequest !== null) return;
        frameRequest = window.requestAnimationFrame(updateState);
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => centerNearestCard(index));
      });

      track.addEventListener(
        'scroll',
        () => {
          requestStateUpdate();
          window.clearTimeout(rebaseTimer);
          rebaseTimer = window.setTimeout(rebaseIfNeeded, 140);
        },
        { passive: true }
      );

      track.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });

      track.addEventListener('mousedown', (event) => {
        isPointerDown = true;
        isDragging = false;
        pointerStart = event.pageX;
        scrollStart = track.scrollLeft;
      });

      track.addEventListener('mousemove', (event) => {
        if (!isPointerDown) return;
        const distance = event.pageX - pointerStart;
        if (!isDragging && Math.abs(distance) > 5) {
          isDragging = true;
          track.classList.add('is-dragging');
        }
        if (!isDragging) return;
        event.preventDefault();
        track.scrollLeft = scrollStart - distance;
      });

      const endDrag = () => {
        if (!isPointerDown) return;
        isPointerDown = false;
        track.classList.remove('is-dragging');
        requestStateUpdate();
        window.clearTimeout(rebaseTimer);
        rebaseTimer = window.setTimeout(rebaseIfNeeded, 140);
        window.setTimeout(() => {
          isDragging = false;
        }, 0);
      };

      track.addEventListener('mouseup', endDrag);
      track.addEventListener('mouseleave', endDrag);
      track.addEventListener('click', (event) => {
        if (isDragging) event.preventDefault();
      });

      const handleResize = () => {
        centerNearestCard(activeIndex, 'auto');
        window.clearTimeout(rebaseTimer);
        rebaseTimer = window.setTimeout(rebaseIfNeeded, 140);
      };
      window.addEventListener('resize', handleResize);
      window.requestAnimationFrame(() => {
        centerOriginalCard(activeIndex);
        updateState();
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-about-makers]').forEach(initializeCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["about-spaces-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeGallery = (root) => {
      if (root.dataset.aboutSpacesReady === 'true') return;
      root.dataset.aboutSpacesReady = 'true';

      const triggers = Array.from(root.querySelectorAll('[data-about-space-trigger]'));
      const lightbox = root.querySelector('[data-about-spaces-lightbox]');
      const lightboxImage = root.querySelector('[data-about-spaces-image]');
      const lightboxCaption = root.querySelector('[data-about-spaces-caption]');
      const closeButtons = Array.from(root.querySelectorAll('[data-about-spaces-close]'));
      if (!lightbox || !lightboxImage || !lightboxCaption || triggers.length === 0) return;

      let activeTrigger = null;
      let closeTimer = null;

      const closeLightbox = () => {
        if (lightbox.hidden) return;
        lightbox.classList.remove('is-open');
        document.documentElement.classList.remove('about-spaces-lightbox-is-open');
        window.clearTimeout(closeTimer);

        const finishClose = () => {
          lightbox.hidden = true;
          lightboxImage.src = '';
          activeTrigger?.focus();
          activeTrigger = null;
        };

        const handleTransitionEnd = (event) => {
          if (event.target !== lightbox || event.propertyName !== 'opacity') return;
          lightbox.removeEventListener('transitionend', handleTransitionEnd);
          finishClose();
        };

        lightbox.addEventListener('transitionend', handleTransitionEnd);
        closeTimer = window.setTimeout(() => {
          lightbox.removeEventListener('transitionend', handleTransitionEnd);
          finishClose();
        }, 500);
      };

      const openLightbox = (trigger) => {
        window.clearTimeout(closeTimer);
        activeTrigger = trigger;
        lightboxImage.src = trigger.dataset.imageSrc || '';
        lightboxImage.alt = trigger.dataset.imageAlt || '';
        lightboxCaption.textContent = trigger.dataset.imageLabel || '';
        lightbox.hidden = false;
        document.documentElement.classList.add('about-spaces-lightbox-is-open');
        window.requestAnimationFrame(() => {
          lightbox.classList.add('is-open');
          lightbox.querySelector('.about-spaces-lightbox__close')?.focus();
        });
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => openLightbox(trigger));
        trigger.addEventListener('dragstart', (event) => event.preventDefault());
      });

      closeButtons.forEach((button) => button.addEventListener('click', closeLightbox));

      lightbox.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeLightbox();
          return;
        }

        if (event.key !== 'Tab') return;
        const closeButton = lightbox.querySelector('.about-spaces-lightbox__close');
        if (!closeButton) return;
        event.preventDefault();
        closeButton.focus();
      });
    };

    const initializeAllGalleries = (scope = document) => {
      scope.querySelectorAll('[data-about-spaces]').forEach(initializeGallery);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllGalleries());
    } else {
      initializeAllGalleries();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAllGalleries(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lead-capture-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-lead-capture]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var dialog = root.querySelector('[data-lead-capture-dialog]');
    var form = root.querySelector('form');
    var emailInput = root.querySelector('input[type="email"]');
    var submitButton = root.querySelector('[data-lead-capture-submit]');
    var submitLabel = root.querySelector('[data-lead-capture-submit-label]');
    var submitLabelText = submitLabel ? submitLabel.textContent.trim() : '';
    var copyButtons = Array.prototype.slice.call(root.querySelectorAll('[data-lead-capture-copy]'));
    var errorMessage = root.querySelector('[data-lead-capture-error]');
    var formState = root.querySelector('[data-lead-capture-form-state]');
    var successState = root.querySelector('[data-lead-capture-success]');
    var storageKey = root.dataset.storageKey;
    var reminderKey = root.dataset.reminderKey;
    var subscribedKey = root.dataset.subscribedKey;
    var autoOpen = root.dataset.autoOpen === 'true';
    var desktopScrollThreshold = Number(root.dataset.desktopScrollThreshold) || 35;
    var mobileScrollThreshold = Number(root.dataset.mobileScrollThreshold) || 40;
    var dismissedDays = Number(root.dataset.dismissedDays) || 3;
    var dismissalCooldownMs = dismissedDays * 24 * 60 * 60 * 1000;
    var reminder = document.querySelector('[data-lead-capture-reminder]');
    var reminderOpenButton = reminder ? reminder.querySelector('[data-lead-capture-reminder-open]') : null;
    var reminderMemoryState = '';
    var subscribedMemoryState = false;
    var isSubmitting = false;
    var isOpen = false;
    var isSubscribed = false;
    var lastFocusedElement = null;
    var closeTimer = null;
    var hasQueuedAutoOpen = false;
    var copyResetTimers = new WeakMap();

    function getReminderState() {
      try {
        return window.localStorage.getItem(reminderKey) || '';
      } catch (error) {
        return reminderMemoryState;
      }
    }

    function setReminderState(state) {
      reminderMemoryState = state;
      try {
        window.localStorage.setItem(reminderKey, state);
      } catch (error) {
        return;
      }
    }

    function hasSubscribed() {
      try {
        return window.localStorage.getItem(subscribedKey) === 'true';
      } catch (error) {
        return subscribedMemoryState;
      }
    }

    function rememberSubscription() {
      subscribedMemoryState = true;
      try {
        window.localStorage.setItem(subscribedKey, 'true');
      } catch (error) {
        return;
      }
    }

    function showReminder() {
      if (!reminder) return;
      reminder.hidden = false;
      reminder.classList.add('is-visible');
    }

    function hideReminder() {
      if (!reminder) return;
      reminder.classList.remove('is-visible');
      reminder.hidden = true;
    }

    function hasBeenSeen() {
      try {
        var storedValue = window.localStorage.getItem(storageKey);
        if (!storedValue) return false;
        var storedTimestamp = Number(storedValue);
        if (!Number.isFinite(storedTimestamp)) return false;
        return Date.now() - storedTimestamp < dismissalCooldownMs;
      } catch (error) {
        return false;
      }
    }

    function rememberDismissal() {
      try {
        window.localStorage.setItem(storageKey, String(Date.now()));
      } catch (error) {
        return;
      }
    }

    function focusableElements() {
      return Array.prototype.slice
        .call(
          dialog.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        )
        .filter(function (element) {
          return !element.hidden && element.offsetParent !== null;
        });
    }

    function setError(message) {
      errorMessage.textContent = message || '';
      errorMessage.hidden = !message;
      emailInput.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    function setLoading(loading) {
      isSubmitting = loading;
      submitButton.disabled = loading;
      if (loading) {
        submitButton.setAttribute('aria-busy', 'true');
        submitLabel.textContent = 'Joining...';
      } else {
        submitButton.removeAttribute('aria-busy');
        submitLabel.textContent = submitLabelText;
      }
    }

    function openPopup(forceOpen) {
      if (!forceOpen && hasSubscribed()) return;
      if ((!forceOpen && hasBeenSeen()) || isOpen) return;
      window.clearTimeout(closeTimer);
      isOpen = true;
      lastFocusedElement = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('lead-capture-is-open');
      document.body.classList.add('lead-capture-is-open');
      var activateOpen = function () {
        root.classList.add('is-open');
        if (!successState.hidden) {
          var shopButton = root.querySelector('[data-lead-capture-shop]');
          if (shopButton) shopButton.focus({ preventScroll: true });
        }
      };
      if (typeof window.requestAnimationFrame === 'function' && !document.hidden) {
        window.requestAnimationFrame(activateOpen);
      } else {
        setTimeout(activateOpen, 20);
      }
    }

    function closePopup() {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('lead-capture-is-open');
      document.body.classList.remove('lead-capture-is-open');
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        root.hidden = true;
      }, 300);
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus({ preventScroll: true });
      }
      rememberDismissal();
      showReminder();
    }

    function showSuccess() {
      setLoading(false);
      setError('');
      form.reset();
      isSubscribed = true;
      rememberSubscription();
      if (window.WrydecoDiscountAutoApply) {
        window.WrydecoDiscountAutoApply.unlockAndSync();
      } else {
        document.dispatchEvent(new CustomEvent('wry:newsletter-signup-success'));
      }
      showReminder();
      formState.hidden = true;
      successState.hidden = false;
      dialog.setAttribute('aria-labelledby', 'LeadCaptureSuccessTitle');
      dialog.setAttribute('aria-describedby', 'LeadCaptureSuccessDescription');
    }

    function handleKeydown(event) {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup();
        return;
      }
      if (event.key !== 'Tab') return;

      var focusable = focusableElements();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!dialog.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
        return;
      }
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function hasValidEmail() {
      emailInput.value = emailInput.value.trim();
      return Boolean(emailInput.value) && emailInput.validity.valid;
    }

    function rejectSubmission() {
      setLoading(false);
      setError('Enter a valid email address.');
      emailInput.focus();
    }

    function fallbackCopy(value) {
      var temporaryInput = document.createElement('textarea');
      temporaryInput.value = value;
      temporaryInput.setAttribute('readonly', '');
      temporaryInput.className = 'lead-capture__clipboard-proxy';
      document.body.appendChild(temporaryInput);
      temporaryInput.select();
      var copied = document.execCommand('copy');
      temporaryInput.remove();
      return copied;
    }

    function copyVoucherCode(value) {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        return navigator.clipboard.writeText(value).catch(function () {
          if (fallbackCopy(value)) return;
          throw new Error('Copy failed');
        });
      }

      return fallbackCopy(value) ? Promise.resolve() : Promise.reject(new Error('Copy failed'));
    }

    function resetCopyIndicator(copyButton) {
      var copyIcon = copyButton.querySelector('[data-lead-capture-copy-icon]');
      var checkIcon = copyButton.querySelector('[data-lead-capture-check-icon]');
      var copyStatus = copyButton.querySelector('[data-lead-capture-copy-status]');
      if (!copyIcon || !checkIcon) return;
      copyButton.classList.remove('is-copied');
      copyButton.setAttribute('aria-label', 'Copy voucher code');
      copyIcon.hidden = false;
      checkIcon.hidden = true;
      if (copyStatus) copyStatus.textContent = '';
      copyResetTimers.delete(copyButton);
    }

    function showCopyIndicator(copyButton) {
      var copyIcon = copyButton.querySelector('[data-lead-capture-copy-icon]');
      var checkIcon = copyButton.querySelector('[data-lead-capture-check-icon]');
      var copyStatus = copyButton.querySelector('[data-lead-capture-copy-status]');
      if (!copyIcon || !checkIcon) return;
      window.clearTimeout(copyResetTimers.get(copyButton));
      copyButton.classList.add('is-copied');
      copyButton.setAttribute('aria-label', 'Voucher code copied');
      copyIcon.hidden = true;
      checkIcon.hidden = false;
      if (copyStatus) copyStatus.textContent = 'Voucher code copied.';
      copyResetTimers.set(
        copyButton,
        window.setTimeout(function () {
          resetCopyIndicator(copyButton);
        }, 2000)
      );
    }

    root.addEventListener('click', function (event) {
      if (event.target === root || event.target.closest('[data-lead-capture-close]')) {
        closePopup();
      }
    });

    emailInput.addEventListener('input', function () {
      if (emailInput.validity.valid) setError('');
    });

    emailInput.addEventListener('invalid', function (event) {
      event.preventDefault();
      rejectSubmission();
    });

    copyButtons.forEach(function (copyButton) {
      copyButton.addEventListener('click', function () {
        var voucherCode = copyButton.dataset.code || '';
        if (!voucherCode) return;

        copyVoucherCode(voucherCode)
          .then(function () {
            showCopyIndicator(copyButton);
            if (window.showToast) {
              window.showToast({
                message: 'Voucher code copied.',
                type: 'success',
                position: 'bottom-left',
                duration: 2000,
              });
            }
          })
          .catch(function () {
            if (window.showToast) {
              window.showToast({
                message: 'Unable to copy the voucher code.',
                type: 'error',
                position: 'bottom-left',
              });
            }
          });
      });
    });

    submitButton.addEventListener(
      'click',
      function (event) {
        if (isSubmitting || !hasValidEmail()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!isSubmitting) rejectSubmission();
        }
      },
      true
    );

    form.addEventListener('submit', function (event) {
      if (isSubmitting) {
        event.preventDefault();
        return;
      }

      if (!hasValidEmail()) {
        event.preventDefault();
        rejectSubmission();
        return;
      }

      setError('');
      setLoading(true);
    });

    document.addEventListener('keydown', handleKeydown);

    if (reminderOpenButton) {
      reminderOpenButton.addEventListener('click', function () {
        openPopup(true);
      });
    }




















    var responseParameters = new URLSearchParams(window.location.search);
    var redirectedSuccessfully =
      responseParameters.get('customer_posted') === 'true' && window.location.hash === '#LeadCaptureForm';
    var postedSuccessfully =
      Boolean(root.querySelector('[data-lead-capture-response-success]')) || redirectedSuccessfully;
    var serverError = root.querySelector('[data-lead-capture-response-error]');

    function getScrollThreshold() {
      return window.matchMedia('(max-width: 48rem)').matches ? mobileScrollThreshold : desktopScrollThreshold;
    }

    var scrollableDistance = 0;

    function measureScrollableDistance() {
      scrollableDistance = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    }

    function getScrollProgress() {
      if (scrollableDistance <= 0) return 100;
      return Math.max(0, Math.min(100, (window.scrollY / scrollableDistance) * 100));
    }

    function maybeOpenFromScroll() {
      if (!autoOpen || hasQueuedAutoOpen || hasBeenSeen() || hasSubscribed()) return;
      if (getScrollProgress() < getScrollThreshold()) return;
      hasQueuedAutoOpen = true;
      window.removeEventListener('scroll', scheduleScrollCheck);
      window.removeEventListener('resize', scheduleScrollMeasurement);
      if (scrollMetricsObserver) scrollMetricsObserver.disconnect();
      openPopup();
    }

    var scrollCheckFrame = null;
    var scrollMetricsDirty = false;
    var scrollMetricsObserver = null;

    function scheduleScrollCheck() {
      if (scrollCheckFrame !== null) return;
      scrollCheckFrame = window.requestAnimationFrame(function () {
        scrollCheckFrame = null;
        if (scrollMetricsDirty) {
          scrollMetricsDirty = false;
          measureScrollableDistance();
        }
        maybeOpenFromScroll();
      });
    }

    function scheduleScrollMeasurement() {
      scrollMetricsDirty = true;
      scheduleScrollCheck();
    }

    if (postedSuccessfully) {
      showSuccess();
      openPopup(true);
    } else if (serverError) {
      setError(serverError.textContent.trim());
      openPopup(true);
    } else if (autoOpen && !hasBeenSeen() && !hasSubscribed()) {
      measureScrollableDistance();
      window.addEventListener('scroll', scheduleScrollCheck, { passive: true });
      window.addEventListener('resize', scheduleScrollMeasurement, { passive: true });
      if ('ResizeObserver' in window) {
        scrollMetricsObserver = new ResizeObserver(scheduleScrollMeasurement);
        scrollMetricsObserver.observe(document.documentElement);
      }
      maybeOpenFromScroll();
    }
    showReminder();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.WrydecoLocalizationPicker) return;

    var state = {
      wrapper: null,
      panel: null,
      activeTrigger: null,
      loadingPromise: null,
      initialized: false,
      searchTimer: null,
      items: [],
      filteredItems: [],
      scrollContainer: null,
      listContainer: null,
      spacer: null,
      empty: null,
      itemHeight: 52, // initial guess
      startIndex: -1,
      endIndex: -1,
      buffer: 10
    };

    function getPanelUrl() {
      var url = new URL(window.location.href);
      url.search = '';
      url.searchParams.set('section_id', 'localization-lazy');
      return url.toString();
    }

    function setTriggersExpanded(expanded) {
      document.querySelectorAll('[data-loc-trigger]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', expanded && trigger === state.activeTrigger ? 'true' : 'false');
      });
    }

    function buildItemHTML(item, top) {
      var searchHay = (item.name + ' ' + item.currency_iso + ' ' + item.currency_symbol).toLowerCase();
      var isSelectedClass = item.is_selected ? ' is-selected' : '';
      var ariaCurrent = item.is_selected ? ' aria-current="true"' : '';
      var flagCode = item.iso_code.toLowerCase();
      
      var flagAlt = item.name.replace(/&/g, '&amp;').replace(/"/g, '&quot;') + ' flag';

      return '<li class="loc-picker__item" style="position: absolute; top: ' + top + 'px; left: 0; right: 0;" data-search="' + searchHay + '">' +
        '<button type="submit" name="country_code" value="' + item.iso_code + '" class="loc-picker__option' + isSelectedClass + '"' + ariaCurrent + '>' +
          '<span class="loc-picker__flag"><img src="https://flagcdn.com/' + flagCode + '.svg" width="40" height="28" loading="lazy" alt="' + flagAlt + '"></span>' +
          '<span class="loc-picker__code">' + item.currency_iso + '</span>' +
          '<span class="loc-picker__symbol">' + item.currency_symbol + '</span>' +
          '<span class="loc-picker__divider" aria-hidden="true"></span>' +
          '<span class="loc-picker__name">' + item.name + '</span>' +
          '<span class="loc-picker__check" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">' +
              '<polyline points="20 6 9 17 4 12"></polyline>' +
            '</svg>' +
          '</span>' +
        '</button>' +
      '</li>';
    }

    function renderVirtualList(force) {
      if (!state.scrollContainer || !state.listContainer) return;
      var scrollTop = state.scrollContainer.scrollTop;
      var containerHeight = state.scrollContainer.clientHeight || 440;
      var totalHeight = state.filteredItems.length * state.itemHeight;
      if (state.spacer) state.spacer.style.height = totalHeight + 'px';

      var newStartIndex = Math.floor(scrollTop / state.itemHeight) - state.buffer;
      var newEndIndex = Math.ceil((scrollTop + containerHeight) / state.itemHeight) + state.buffer;

      newStartIndex = Math.max(0, newStartIndex);
      newEndIndex = Math.min(state.filteredItems.length - 1, newEndIndex);

      if (!force && newStartIndex === state.startIndex && newEndIndex === state.endIndex) {
        return;
      }

      state.startIndex = newStartIndex;
      state.endIndex = newEndIndex;

      var html = '';
      for (var i = state.startIndex; i <= state.endIndex; i++) {
        html += buildItemHTML(state.filteredItems[i], i * state.itemHeight);
      }
      state.listContainer.innerHTML = html;
    }

    function filterItems(query) {
      var q = (query || '').trim().toLowerCase();
      state.filteredItems = state.items.filter(function(item) {
        var hay = (item.name + ' ' + item.currency_iso + ' ' + item.currency_symbol).toLowerCase();
        return !q || hay.indexOf(q) !== -1;
      });

      if (state.empty) {
        state.empty.hidden = state.filteredItems.length > 0;
      }
      
      state.startIndex = -1; // force re-render
      if (state.scrollContainer) state.scrollContainer.scrollTop = 0;
      renderVirtualList(true);
    }

    function closePanel(restoreFocus) {
      if (!state.wrapper) return;
      state.wrapper.remove(); // Unmount from DOM completely
      if (state.panel) state.panel.hidden = false;
      setTriggersExpanded(false);

      if (restoreFocus && state.activeTrigger) state.activeTrigger.focus();
      state.activeTrigger = null;
    }

    function initPanel() {
      if (!state.panel || state.initialized) return;
      state.initialized = true;

      var closeButtons = state.panel.querySelectorAll('[data-loc-close]');
      var search = state.panel.querySelector('[data-loc-search]');

      var dataScript = state.panel.querySelector('[data-loc-data]');
      if (dataScript) {
        try {
          state.items = JSON.parse(dataScript.textContent);
        } catch(e) {
          state.items = [];
        }
      }
      state.scrollContainer = state.panel.querySelector('[data-loc-scroll-container]');
      state.listContainer = state.panel.querySelector('[data-loc-list]');
      state.spacer = state.panel.querySelector('[data-loc-spacer]');
      state.empty = state.panel.querySelector('[data-loc-empty]');

      if (state.scrollContainer) {
        state.scrollContainer.addEventListener('scroll', function() {
          renderVirtualList();
        });
      }

      closeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          closePanel(true);
        });
      });

      if (search) {
        search.addEventListener('input', function () {
          window.clearTimeout(state.searchTimer);
          state.searchTimer = window.setTimeout(function () {
            filterItems(search.value);
          }, 200);
        });

        search.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') event.preventDefault();
        });
      }

      state.panel.addEventListener('click', function (event) {
        if (event.target.hasAttribute('data-loc-overlay')) closePanel(true);
      });

      document.addEventListener('keydown', function (event) {
        if (!state.wrapper || !state.wrapper.parentNode) return;
        if (event.key === 'Escape') closePanel(true);
      });
    }

    function loadPanel() {
      if (state.panel) return Promise.resolve(state.panel);
      if (state.loadingPromise) return state.loadingPromise;

      state.loadingPromise = fetch(getPanelUrl(), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Localization panel failed to load.');
          return response.text();
        })
        .then(function (html) {
          state.wrapper = document.createElement('div');
          state.wrapper.setAttribute('data-loc-panel-root', '');
          state.wrapper.innerHTML = html;
          state.panel = state.wrapper.querySelector('[data-loc-panel]');
          if (!state.panel) throw new Error('Localization panel markup was not found.');
          document.body.appendChild(state.wrapper);
          initPanel();
          return state.panel;
        })
        .catch(function (error) {
          state.loadingPromise = null;
          throw error;
        });

      return state.loadingPromise;
    }

    function openPanel(trigger) {
      state.activeTrigger = trigger;
      setTriggersExpanded(true);

      if (state.wrapper) {
        document.body.appendChild(state.wrapper); // Mount back to DOM
        state.panel.hidden = false;
        
        if (state.items.length > 0 && state.listContainer && state.itemHeight === 52) {
           state.listContainer.innerHTML = buildItemHTML(state.items[0], 0);
           var firstChild = state.listContainer.children[0];
           state.itemHeight = (firstChild && firstChild.offsetHeight) ? firstChild.offsetHeight : 52;
           state.listContainer.innerHTML = '';
        }

        filterItems('');
        var search = state.panel.querySelector('[data-loc-search]');
        if (search) {
          search.value = '';
          window.requestAnimationFrame(function () {
            search.focus({ preventScroll: true });
          });
        }
        return;
      }

      // Show skeleton loader immediately
      var skeleton = document.createElement('div');
      skeleton.setAttribute('data-loc-panel-root', 'skeleton');
      skeleton.innerHTML = '<div style="position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding: 16px; background: rgba(0,0,0,0.44);"><div style="position:relative; width: min(420px, 100vw - 24px); height: 200px; background: var(--color-milk, #fff); border-radius: 32px; display:flex; align-items:center; justify-content:center; box-shadow: 0 4px 20px rgba(0,0,0,0.1);"><svg style="animation: loc-spin 1s linear infinite; width: 32px; height: 32px; color: var(--color-earth-brown, #6D5E50);" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" stroke-opacity="0.25"></circle><path d="M12 2a10 10 0 0 1 10 10" stroke-opacity="0.8"></path></svg><style>@keyframes loc-spin { 100% { transform: rotate(360deg); } }</style></div></div>';
      document.body.appendChild(skeleton);

      // Wait 2 frames before calling API to ensure UI is not blocked
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          loadPanel()
            .then(function (panel) {
              skeleton.remove();
              panel.hidden = false;
              
              if (state.items.length > 0 && state.listContainer && state.itemHeight === 52) {
                 state.listContainer.innerHTML = buildItemHTML(state.items[0], 0);
                 var firstChild = state.listContainer.children[0];
                 state.itemHeight = (firstChild && firstChild.offsetHeight) ? firstChild.offsetHeight : 52;
                 state.listContainer.innerHTML = '';
              }

              filterItems('');
              var search = panel.querySelector('[data-loc-search]');
              if (search) {
                search.value = '';
                window.requestAnimationFrame(function () {
                  search.focus({ preventScroll: true });
                });
              }
            })
            .catch(function () {
              skeleton.remove();
              closePanel(false);
            });
        });
      });
    }

    function handleTriggerClick(event) {
      var trigger = event.target.closest('[data-loc-trigger]');
      if (!trigger) return;

      event.preventDefault();
      if (state.wrapper && state.wrapper.parentNode && state.activeTrigger === trigger) {
        closePanel(true);
        return;
      }

      openPanel(trigger);
    }

    document.addEventListener('click', handleTriggerClick);

    window.WrydecoLocalizationPicker = {
      open: openPanel,
      close: closePanel,
      load: loadPanel
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-price"] && !Shopify.designMode) return;
  try {
    (function () {
    function initPriceUpdater() {
      var container = document.querySelector('[data-price-container]');
      var mapEl = document.querySelector('[data-variant-prices]');
      if (!container || !mapEl || container.dataset.priceInit === 'true') return;

      var map;
      try {
        map = JSON.parse(mapEl.textContent);
      } catch (e) {
        return;
      }
      container.dataset.priceInit = 'true';

      var regularEls = document.querySelectorAll('[data-regular-price]');
      var compareEl = container.querySelector('[data-compare-price]');
      var savingsEl = container.querySelector('[data-savings-price]');

      // Global entry point called by the variant picker the moment a variant is
      // selected. Updates text content in place (nodes stay stable, so the sticky
      // bar's price mirror keeps working).
      window.updateProductPrice = function (variantId) {
        var data = map[String(variantId)];
        if (!data || regularEls.length === 0) return;

        regularEls.forEach(function (regularEl) {
          regularEl.textContent = data.price;
        });

        if (data.onSale) {
          container.classList.add('product-price--has-sale');
          if (compareEl) {
            compareEl.textContent = data.compareAt;
            compareEl.style.display = '';
          }
          if (savingsEl) {
            savingsEl.innerHTML = '<span>Save </span><span>' + data.savings + '</span>';
            savingsEl.style.display = '';
          }
        } else {
          container.classList.remove('product-price--has-sale');
          if (compareEl) {
            compareEl.textContent = '';
            compareEl.style.display = 'none';
          }
          if (savingsEl) {
            savingsEl.innerHTML = '';
            savingsEl.style.display = 'none';
          }
        }
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPriceUpdater);
    } else {
      initPriceUpdater();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-trust-benefits"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializedRoots = new WeakSet();

    const initializeBenefitDrawer = (root) => {
      if (initializedRoots.has(root)) return;
      initializedRoots.add(root);

      const drawer = root.querySelector('[data-benefit-drawer]');
      const panel = root.querySelector('[data-benefit-panel]');
      const scroller = root.querySelector('.product-benefit-drawer__scroll');
      const triggers = [...root.querySelectorAll('[data-benefit-open]')];
      const views = [...root.querySelectorAll('[data-benefit-view]')];
      let activeTrigger = null;
      let closeTimer = null;

      if (!drawer || !panel || !triggers.length || !views.length) return;

      if (drawer.parentElement !== document.body) {
        document.body.appendChild(drawer);
      }

      const closeDrawer = () => {
        if (drawer.hidden) return;
        window.clearTimeout(closeTimer);
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));

        closeTimer = window.setTimeout(() => {
          drawer.hidden = true;
          views.forEach((view) => {
            view.hidden = true;
          });
          if (activeTrigger instanceof HTMLElement) activeTrigger.focus({ preventScroll: true });
          activeTrigger = null;
        }, 300);
      };

      const openDrawer = (trigger) => {
        const name = trigger.dataset.benefitOpen;
        const view = views.find((candidate) => candidate.dataset.benefitView === name);
        if (!view) return;

        window.clearTimeout(closeTimer);
        activeTrigger = trigger;
        views.forEach((candidate) => {
          candidate.hidden = candidate !== view;
        });
        triggers.forEach((candidate) => {
          candidate.setAttribute('aria-expanded', candidate === trigger ? 'true' : 'false');
        });

        const title = view.querySelector('h2[id]');
        if (title) panel.setAttribute('aria-labelledby', title.id);
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        if (scroller) scroller.scrollTop = 0;
        window.requestAnimationFrame(() => {
          drawer.classList.add('is-open');
          panel.focus({ preventScroll: true });
        });
      };

      const preventBackgroundScroll = (event) => {
        if (!event.target.closest('.product-benefit-drawer__scroll')) event.preventDefault();
      };

      drawer.addEventListener('wheel', preventBackgroundScroll, { passive: false });
      drawer.addEventListener('touchmove', preventBackgroundScroll, { passive: false });

      root.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-benefit-open]');
        if (trigger && root.contains(trigger)) {
          openDrawer(trigger);
          return;
        }

        if (event.target.closest('[data-benefit-close]')) closeDrawer();
      });

      drawer.addEventListener('click', (event) => {
        if (event.target.closest('[data-benefit-close]')) closeDrawer();
      });

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDrawer();
          return;
        }

        if (event.key !== 'Tab') return;
        const focusable = [
          ...panel.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
          ),
        ].filter((element) => !element.closest('[hidden]'));
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    };

    const initializeBenefitDrawers = () => {
      document.querySelectorAll('[data-product-benefits]').forEach(initializeBenefitDrawer);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeBenefitDrawers, { once: true });
    } else {
      initializeBenefitDrawers();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    // --- 1. Press-and-hold to scroll the variant lists horizontally ---
    // Mirrors the drag logic used by .product-gallery__thumbnails.
    function initVariantDragScroll() {
      document.querySelectorAll('.variant-group__list').forEach(function (list) {
        if (list.dataset.dragInit === 'true') return;
        list.dataset.dragInit = 'true';

        var isDown = false;
        var startX = 0;
        var scrollLeft = 0;
        var isDragging = false;

        // Never let a press-and-hold start a native image/element drag.
        list.addEventListener('dragstart', function (e) {
          e.preventDefault();
        });

        list.addEventListener('mousedown', function (e) {
          isDown = true;
          isDragging = false;
          list.classList.add('is-active-drag');
          startX = e.pageX - list.offsetLeft;
          scrollLeft = list.scrollLeft;
        });
        list.addEventListener('mouseleave', function () {
          isDown = false;
          list.classList.remove('is-active-drag');
        });
        list.addEventListener('mouseup', function () {
          isDown = false;
          list.classList.remove('is-active-drag');
        });
        list.addEventListener('mousemove', function (e) {
          if (!isDown) return;
          e.preventDefault();
          var x = e.pageX - list.offsetLeft;
          var walk = (x - startX) * 2; // scroll speed multiplier
          if (Math.abs(walk) > 5) isDragging = true;
          list.scrollLeft = scrollLeft - walk;
        });
        // Swallow the click that ends a drag so it doesn't select a variant.
        list.addEventListener(
          'click',
          function (e) {
            if (isDragging) {
              e.stopPropagation();
              e.preventDefault();
            }
          },
          true
        );
      });
    }

    // --- 2. Variant selection: instant price / gallery / URL updates ---
    function initVariantSelect() {
      var picker = document.querySelector('.product-variant-picker');
      if (!picker) return;

      // Variant data + per-variant images come from the JSON island (rendered
      // by Liquid) instead of a large inline `product.variants | json` dump.
      var dataEl = document.querySelector('[data-variant-picker-data]');
      var pickerData = {};
      try {
        pickerData = JSON.parse((dataEl && dataEl.textContent) || '{}');
      } catch (e) {
        pickerData = {};
      }
      var productVariants = pickerData.variants || [];
      var variantMetafieldsMap = pickerData.variantImages || {};

      var selectedOptions = {};

      // Initialise from the inputs that are already checked.
      document.querySelectorAll('.product-variant-picker input[type="radio"]:checked').forEach(function (input) {
        selectedOptions[input.dataset.index] = input.value;
      });

      var variantInputs = document.querySelectorAll('.product-variant-picker input[type="radio"]');

      var getSelectedOptions = function () {
        var nextSelectedOptions = {};
        document.querySelectorAll('.product-variant-picker input[type="radio"]:checked').forEach(function (input) {
          nextSelectedOptions[input.dataset.index] = input.value;
        });
        return nextSelectedOptions;
      };

      var findVariantForOptions = function (options) {
        return productVariants.find(function (variant) {
          return Object.keys(options).every(function (key) {
            return variant[key] === options[key];
          });
        });
      };

      var isOptionValuePickable = function (input) {
        var candidateOptions = Object.assign({}, selectedOptions);
        candidateOptions[input.dataset.index] = input.value;

        return productVariants.some(function (variant) {
          if (!variant.available) return false;

          return Object.keys(candidateOptions).every(function (key) {
            return variant[key] === candidateOptions[key];
          });
        });
      };

      var syncOptionAvailability = function () {
        Object.assign(selectedOptions, getSelectedOptions());

        variantInputs.forEach(function (input) {
          var tile = input.closest('.variant-tile');
          var isCurrentSelection = input.checked;
          var isPickable = isCurrentSelection || isOptionValuePickable(input);

          input.disabled = !isPickable;
          input.setAttribute('aria-disabled', isPickable ? 'false' : 'true');
          if (tile) tile.classList.toggle('is-disabled', !isPickable);
        });
      };

      syncOptionAvailability();

      var variantChangeRequest = 0;
      var runAfterPickerPaint = function (callback) {
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(callback);
          });
        } else {
          window.setTimeout(callback, 0);
        }
      };

      variantInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          // Keep the actual radio/check indicator responsive: let the browser
          // paint the native checked state before the heavier availability and
          // gallery work runs.
          selectedOptions[input.dataset.index] = input.value;
          var requestId = ++variantChangeRequest;

          runAfterPickerPaint(function () {
            if (requestId !== variantChangeRequest) return;

            syncOptionAvailability();

            // Find the variant matching the full set of selected options.
            var selectedVariant = findVariantForOptions(selectedOptions);
            if (!selectedVariant) return;

            // Instant, no-API updates the moment a variant is picked:
            // price + compare + "Save", the hidden variant id used by the form,
            // the add-to-cart button state, and the ?variant= URL param.
            if (window.updateProductPrice) {
              window.updateProductPrice(selectedVariant.id);
            }

            var variantIdInput = document.querySelector('[data-variant-id]');
            if (variantIdInput) variantIdInput.value = selectedVariant.id;

            var addText = document.querySelector('[data-add-to-cart-text]');
            var addBtn = document.querySelector('form[data-type="add-to-cart-form"] button[name="add"]');
            if (addText) addText.textContent = selectedVariant.available ? 'ADD TO CART' : 'SOLD OUT';
            if (addBtn) addBtn.disabled = !selectedVariant.available;

            var availBadge = document.querySelector('[data-variant-availability]');
            var availLink = document.querySelector('[data-variant-availability-link]');
            if (availBadge) {
              if (selectedVariant.available) {
                availBadge.className = 'product-availability product-availability--in-stock';
                availBadge.innerHTML = '<link itemprop="availability" href="https://schema.org/InStock" data-variant-availability-link><span class="product-availability__dot" aria-hidden="true"></span><span class="product-availability__text">In Stock</span>';
              } else {
                availBadge.className = 'product-availability product-availability--out-of-stock';
                availBadge.innerHTML = '<link itemprop="availability" href="https://schema.org/OutOfStock" data-variant-availability-link><span class="product-availability__dot" aria-hidden="true"></span><span class="product-availability__text">Out of Stock</span>';
              }
            }
            if (availLink) {
              availLink.setAttribute('href', selectedVariant.available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock');
            }

            if (window.history && window.history.replaceState) {
              var nextUrl = new URL(window.location.href);
              nextUrl.searchParams.set('variant', selectedVariant.id);
              window.history.replaceState({}, '', nextUrl);
            }

            // Let other components (e.g. the gallery wishlist heart) react to the
            // newly-selected variant. Fired after the form id and URL are updated.
            document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: selectedVariant.id } }));

            // Filter the gallery by the variant's `variant_images` metafield.
            var variantImagesRaw = variantMetafieldsMap[selectedVariant.id];
            if (variantImagesRaw) {
              var variantImages = variantImagesRaw
                .split('\n')
                .map(function (s) {
                  return s.trim().replace(/<br\s*\/?>/g, '');
                })
                .filter(function (s) {
                  return s !== '';
                });

              if (variantImages.length > 0) {
                var thumbnails = document.querySelectorAll('.product-gallery__thumbnail');
                var mainItems = document.querySelectorAll('.product-gallery__main-item');

                var firstMatchedThumbnail = null;

                thumbnails.forEach(function (thumb) {
                  if (thumb.dataset.thumbnailId === 'product-video-media') {
                    thumb.style.display = '';
                    return;
                  }

                  var alt = thumb.dataset.alt || '';
                  var isMatch = variantImages.some(function (vImg) {
                    return alt.includes(vImg);
                  });

                  if (isMatch) {
                    thumb.style.display = '';
                    if (!firstMatchedThumbnail) firstMatchedThumbnail = thumb;
                  } else {
                    thumb.style.display = 'none';
                    thumb.classList.remove('is-active');
                  }
                });

                mainItems.forEach(function (item) {
                  if (item.dataset.mainMediaId === 'product-video-media') return;

                  var alt = item.dataset.alt || '';
                  var isMatch = variantImages.some(function (vImg) {
                    return alt.includes(vImg);
                  });
                  if (!isMatch) {
                    item.classList.remove('is-active');
                  }
                });

                if (firstMatchedThumbnail) {
                  firstMatchedThumbnail.click();
                }
              } else {
                document.querySelectorAll('.product-gallery__thumbnail').forEach(function (t) {
                  t.style.display = '';
                });
              }
            } else {
              document.querySelectorAll('.product-gallery__thumbnail').forEach(function (t) {
                t.style.display = '';
              });
            }
          });
        });
      });
    }

    // --- 3. Custom-colour upload tile ---
    // The custom-colour tile IS the "Custom" wood-finish value. Uploading an
    // image selects that value (checking its real radio, so it stays a single,
    // mutually-exclusive choice) and attaches the uploaded URL to the product
    // form as the `added_url_image` line-item property, which travels into the
    // cart alongside the chosen size and surface.
    function initCustomColorUpload() {
      var MAX_BYTES = 10 * 1024 * 1024;

      function toast(message, type) {
        if (window.showToast) {
          window.showToast({ message: message, type: type, position: 'bottom-left', duration: 4000 });
        }
      }

      // Shared guidance popup — shown before the real file picker opens.
      var guide = document.querySelector('[data-custom-color-guide]');
      var pendingContinue = null;
      function closeGuide() {
        if (!guide) return;
        guide.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        pendingContinue = null;
      }
      function openGuide(onContinue) {
        // No popup in the DOM → keep the original behaviour (open the file dialog directly).
        if (!guide) {
          if (onContinue) onContinue();
          return;
        }
        pendingContinue = onContinue;
        guide.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        var btn = guide.querySelector('[data-custom-color-guide-continue]');
        if (btn) btn.focus();
      }
      if (guide && guide.dataset.guideInit !== 'true') {
        guide.dataset.guideInit = 'true';
        guide.querySelectorAll('[data-custom-color-guide-close]').forEach(function (el) {
          el.addEventListener('click', closeGuide);
        });
        var continueBtn = guide.querySelector('[data-custom-color-guide-continue]');
        if (continueBtn) {
          continueBtn.addEventListener('click', function () {
            // Capture before closing (close clears it); running it here keeps the
            // user gesture, so the browser allows the file dialog to open.
            var next = pendingContinue;
            closeGuide();
            if (next) next();
          });
        }
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && guide.classList.contains('is-open')) closeGuide();
        });
      }

      document.querySelectorAll('[data-custom-color]:not([data-custom-color-init])').forEach(function (tile) {
        tile.dataset.customColorInit = 'true';

        var fileInput = tile.querySelector('[data-custom-color-input]');
        var radio = tile.querySelector('[data-custom-color-radio]');
        var icon = tile.querySelector('[data-custom-color-icon]');
        var spinner = tile.querySelector('[data-custom-color-spinner]');
        var preview = tile.querySelector('[data-custom-color-preview]');
        var label = tile.querySelector('[data-custom-color-label]');
        var property = tile.querySelector('[data-custom-color-property]');
        if (!fileInput || !radio) return;

        // The file input lives inside the tile, so a programmatic fileInput.click()
        // would bubble back to the tile's click handler and re-open the guide popup.
        // Stop it here so opening the file dialog never re-triggers the tile.
        fileInput.addEventListener('click', function (e) {
          e.stopPropagation();
        });

        var uploadedUrl = '';
        var defaultLabel = label ? label.textContent : 'Custom color';

        // Attach the URL only while the custom finish is the active choice.
        function syncProperty() {
          if (!property) return;
          if (radio.checked && uploadedUrl) {
            property.value = uploadedUrl;
            property.disabled = false;
          } else {
            property.value = '';
            property.disabled = true;
          }
        }

        function selectCustom() {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          syncProperty();
        }

        function setLoading(loading) {
          tile.classList.toggle('is-loading', loading);
          if (spinner) spinner.hidden = !loading;
          if (icon) icon.hidden = loading || tile.classList.contains('is-uploaded');
          if (label) label.textContent = loading ? 'Uploading…' : defaultLabel;
        }

        function upload(file) {
          if (file.size > MAX_BYTES) {
            toast('Image exceeds 10MB limit.', 'error');
            return;
          }

          setLoading(true);

          var api = window.WrydecoApi;
          var uploadPromise =
            api && typeof api.uploadCustomColorImage === 'function'
              ? api.uploadCustomColorImage(file)
              : (function () {
                  var formData = new FormData();
                  formData.append('image', file);
                  return fetch('https://admin.wrydeco.com/api/upload-image', { method: 'POST', body: formData }).then(
                    function (response) {
                      return response
                        .json()
                        .catch(function () {
                          return {};
                        })
                        .then(function (data) {
                          return { ok: response.ok, data: data };
                        });
                    }
                  );
                })();

          uploadPromise
            .then(function (result) {
              if (result && result.ok && result.data && result.data.image_url) {
                uploadedUrl = result.data.image_url;
                if (preview) {
                  preview.src = uploadedUrl;
                  preview.hidden = false;
                }
                if (icon) icon.hidden = true;
                tile.classList.add('is-uploaded');
                selectCustom(); // the uploaded image becomes the selected custom finish
                toast('Custom color uploaded.', 'success');
              } else {
                var detail =
                  (result && result.data && (result.data.detail || result.data.message)) ||
                  'Upload failed. Please try again.';
                toast(typeof detail === 'string' ? detail : 'Upload failed. Please try again.', 'error');
              }
            })
            .catch(function () {
              toast('Upload failed. Please try again.', 'error');
            })
            .finally(function () {
              setLoading(false);
              fileInput.value = ''; // allow re-picking the same file
            });
        }

        fileInput.addEventListener('change', function () {
          var file = fileInput.files && fileInput.files[0];
          if (file) upload(file);
        });

        // Empty → pick a file. Uploaded but not selected → select it.
        // Already the active choice → pick again to replace the image.
        // Unavailable for the current size/surface → behave like a disabled tile.
        tile.addEventListener('click', function () {
          if (tile.classList.contains('is-loading')) return;
          if (radio.disabled || tile.classList.contains('is-disabled')) return;
          if (!uploadedUrl || radio.checked) {
            // Show the guidance popup first; the file dialog opens only on "Continue".
            openGuide(function () {
              fileInput.click();
            });
          } else {
            selectCustom();
          }
        });

        // Keep the property in step when the finish selection changes elsewhere.
        var groupName = radio.getAttribute('name');
        document.querySelectorAll('input[name="' + groupName + '"]').forEach(function (r) {
          r.addEventListener('change', syncProperty);
        });

        syncProperty();

        // Fresh load with the "Custom" variant selected via URL (e.g. ?variant=…)
        // server-renders this radio as checked — but no image has been uploaded
        // this session (uploadedUrl is in-memory only). Never leave Custom
        // pre-selected without an image: fall back to the first available
        // non-custom value in the same option group (prefer an in-stock one).
        if (radio.checked && !uploadedUrl) {
          var available = null;
          var anySibling = null;
          document.querySelectorAll('input[name="' + groupName + '"]').forEach(function (r) {
            if (r === radio) return;
            if (!anySibling) anySibling = r;
            if (!available && !r.disabled) available = r;
          });
          var fallbackRadio = available || anySibling;
          radio.checked = false;
          if (fallbackRadio) {
            fallbackRadio.checked = true;
            // Let the variant-select handler update price / gallery / ?variant= URL.
            fallbackRadio.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            syncProperty();
          }
        }
      });
    }

    // --- 4. Hide a variant tile's media box when its image fails to load ---
    // Variants with no image never render a media box (handled in Liquid); this
    // covers the case where an image URL exists but 404s / errors, so the empty
    // grey placeholder is removed instead of shown.
    function initVariantMediaFallback() {
      function hideMedia(img) {
        var media = img.closest('.variant-tile__media');
        if (media) media.hidden = true;
      }
      document.querySelectorAll('[data-variant-media-img]').forEach(function (img) {
        if (img.dataset.mediaFallbackInit === 'true') return;
        img.dataset.mediaFallbackInit = 'true';

        if (img.complete) {
          // Already finished loading (e.g. cached) — naturalWidth 0 means it errored.
          if (img.naturalWidth === 0) hideMedia(img);
          return;
        }
        img.addEventListener('error', function () {
          hideMedia(img);
        });
      });
    }

    // --- 5. Size-guide popup custom element ---
    function initSizeGuide() {
      if (customElements.get('size-guide-popup')) return;
      customElements.define(
        'size-guide-popup',
        class extends HTMLElement {
          constructor() {
            super();
            this.overlay = this.querySelector('.size-guide-popup__overlay');
            this.closeBtn = this.querySelector('.size-guide-popup__close');

            if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));
            if (this.overlay) {
              this.overlay.addEventListener('click', (e) => {
                if (e.target === this.overlay) this.close();
              });
            }
            document.addEventListener('keydown', (e) => {
              if (e.key === 'Escape' && this.hasAttribute('open')) this.close();
            });

            window.openSizeGuidePopup = (e) => {
              if (e) e.preventDefault();
              this.open();
            };
          }

          open() {
            this.setAttribute('open', '');
            this.setAttribute('aria-hidden', 'false');
            this.removeAttribute('inert');
            document.body.style.overflow = 'hidden';
          }

          close() {
            this.removeAttribute('open');
            this.setAttribute('aria-hidden', 'true');
            this.setAttribute('inert', '');
            document.body.style.overflow = '';
          }
        }
      );
    }

    // --- 6. Size "Custom" request popup ---
    // Clicking the size "Custom" tile opens a popup where the shopper describes
    // the size they want and leaves a contact. Submitting POSTs a Custom Size
    // Request (multipart FormData) to the server — a lead for the production team.
    // It does not select a variant or add to cart.
    function initCustomSizeNote() {
      var popup = document.querySelector('[data-custom-size-popup]');
      var tiles = document.querySelectorAll('[data-custom-size]:not([data-custom-size-init])');
      if (!popup || tiles.length === 0) return;

      var textarea = popup.querySelector('[data-custom-size-note]');
      var contact = popup.querySelector('[data-custom-size-contact]');
      var saveBtn = popup.querySelector('[data-custom-size-save]');
      var saveLabel = popup.querySelector('[data-custom-size-save-label]');
      var defaultLabel = saveLabel ? saveLabel.textContent : 'Submit request';

      function toast(message, type) {
        if (window.showToast) {
          window.showToast({ message: message, type: type, position: 'bottom-left', duration: 4000 });
        }
      }

      // Per-field inline errors, keyed by the popup's field names.
      var fieldEls = { note: textarea, contact: contact };
      function setError(field, message) {
        var input = fieldEls[field];
        var el = popup.querySelector('[data-custom-size-error="' + field + '"]');
        if (input) input.setAttribute('aria-invalid', 'true');
        if (el) {
          el.textContent = message;
          el.hidden = false;
        }
      }
      function clearError(field) {
        var input = fieldEls[field];
        var el = popup.querySelector('[data-custom-size-error="' + field + '"]');
        if (input) input.removeAttribute('aria-invalid');
        if (el) {
          el.textContent = '';
          el.hidden = true;
        }
      }
      function clearAllErrors() {
        clearError('note');
        clearError('contact');
      }

      // Clear a field's error the moment the shopper starts fixing it.
      if (textarea) textarea.addEventListener('input', function () { clearError('note'); });
      if (contact) contact.addEventListener('input', function () { clearError('contact'); });

      var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      function isValidContact(value) {
        if (EMAIL_RE.test(value)) return true;
        var digits = value.replace(/\D/g, '');
        return digits.length >= 7 && digits.length <= 15 && /^[+()\d\s.-]+$/.test(value);
      }

      function validate() {
        clearAllErrors();
        var firstInvalid = null;
        var note = textarea ? textarea.value.trim() : '';
        var contactValue = contact ? contact.value.trim() : '';

        if (!note) {
          setError('note', 'Please describe the size you want.');
          firstInvalid = firstInvalid || textarea;
        } else if (note.length < 5) {
          setError('note', 'Please add a little more detail (at least 5 characters).');
          firstInvalid = firstInvalid || textarea;
        }

        if (!contactValue) {
          setError('contact', 'An email or phone number is required.');
          firstInvalid = firstInvalid || contact;
        } else if (!isValidContact(contactValue)) {
          setError('contact', 'Enter a valid email or phone number.');
          firstInvalid = firstInvalid || contact;
        }

        if (firstInvalid && firstInvalid.focus) firstInvalid.focus();
        return !firstInvalid;
      }

      function setLoading(loading) {
        if (saveBtn) saveBtn.disabled = loading;
        if (saveLabel) saveLabel.textContent = loading ? 'Sending…' : defaultLabel;
      }

      function closePopup() {
        popup.hidden = true;
        document.documentElement.style.overflow = '';
      }

      function openPopup() {
        clearAllErrors();
        popup.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        if (textarea) textarea.focus();
      }

      popup.querySelectorAll('[data-custom-size-popup-close]').forEach(function (el) {
        el.addEventListener('click', closePopup);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !popup.hidden) closePopup();
      });

      function submit() {
        if (!validate()) return;

        var formData = new FormData();
        formData.append('product_id', popup.dataset.productId || '');
        formData.append('product_handle', popup.dataset.productHandle || '');
        formData.append('product_name', popup.dataset.productName || '');
        formData.append('custom_size_description', textarea.value.trim());
        formData.append('customer_contact', contact.value.trim());

        setLoading(true);

        var api = window.WrydecoApi;
        var requestPromise =
          api && typeof api.submitCustomSizeRequest === 'function'
            ? api.submitCustomSizeRequest(formData)
            : fetch('https://admin.wrydeco.com/api/custom-size-requests', { method: 'POST', body: formData }).then(
                function (response) {
                  return response
                    .json()
                    .catch(function () {
                      return null;
                    })
                    .then(function (data) {
                      return { ok: response.ok, status: response.status, data: data };
                    });
                }
              );

        requestPromise
          .then(function (response) {
            if (response && response.ok) {
              toast("Thank you — we've received your request and will contact you shortly.", 'success');
              if (textarea) textarea.value = '';
              if (contact) contact.value = '';
              clearAllErrors();
              closePopup();
              return;
            }
            // Map the API's structured field errors back onto the inputs.
            var data = response && response.data;
            var mapped = false;
            if (data && Array.isArray(data.errors)) {
              data.errors.forEach(function (err) {
                if (err.field === 'custom_size_description') {
                  setError('note', err.message);
                  mapped = true;
                } else if (err.field === 'customer_contact') {
                  setError('contact', err.message);
                  mapped = true;
                }
              });
            }
            if (!mapped) {
              toast((data && data.message) || 'Something went wrong. Please try again.', 'error');
            }
          })
          .catch(function () {
            toast('Something went wrong. Please try again.', 'error');
          })
          .finally(function () {
            setLoading(false);
          });
      }

      if (saveBtn) saveBtn.addEventListener('click', submit);

      tiles.forEach(function (tile) {
        tile.dataset.customSizeInit = 'true';
        tile.addEventListener('click', openPopup);
        // Keyboard support for the role="button" tile.
        tile.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openPopup();
          }
        });
      });
    }

    function init() {
      initVariantDragScroll();
      initVariantSelect();
      initCustomColorUpload();
      initVariantMediaFallback();
      initSizeGuide();
      initCustomSizeNote();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-customize"] && !Shopify.designMode) return;
  try {
    (function () {
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cache = {}; // handle -> product JSON from /products/{handle}.js
    var requestId = 0; // guards against out-of-order fetches
    var bound = false; // whether global (document) listeners are attached

    var modal = null; // the single active dialog element
    var els = null; // cached child references of `modal`
    var state = null; // { product, selected: [], variant, optionNames: [] }
    var addLabel = 'Add to cart';
    var buyLabel = 'Buy it now';
    var moneyFormat = '${{amount}}';
    var toastPosition = 'bottom-left';
    var lastFocused = null; // element to restore focus to on close

    // Custom "Custom" handling (mirrors the PDP variant picker).
    var MAX_UPLOAD_BYTES = 10 * 1024 * 1024;

    // Sub-dialogs rendered once alongside the main dialog; cached in wireModal().
    var guide = null; // custom-colour upload guidance popup
    var fileInput = null; // hidden device file input
    var sizePopup = null; // custom size request form
    var pendingGuideContinue = null; // runs when the guide's "Continue" is pressed
    var pendingColorCommit = null; // commits the "Custom" colour/finish selection once its reference image uploads

    // Sub-dialog open/close animation: mirror the main dialog's `is-open` pattern
    // (unhide → next frame add `is-open`; remove `is-open` → hide after the fade).
    var SUBDIALOG_HIDE_MS = 240;

    function showSubDialog(el, timerRef) {
      if (!el) return;
      if (timerRef.id) {
        clearTimeout(timerRef.id);
        timerRef.id = null;
      }
      el.hidden = false;
      window.requestAnimationFrame(function () {
        el.classList.add('is-open');
      });
    }

    function hideSubDialog(el, timerRef) {
      if (!el) return;
      el.classList.remove('is-open');
      if (timerRef.id) clearTimeout(timerRef.id);
      timerRef.id = window.setTimeout(function () {
        el.hidden = true;
        timerRef.id = null;
      }, SUBDIALOG_HIDE_MS);
    }

    // Small holders so the timer id is shared by reference across show/hide.
    var guideTimer = { id: null };
    var sizeTimer = { id: null };
    var customImage = { url: '', optionIndex: -1 }; // uploaded URL + which option it belongs to

    function toast(message, type) {
      if (window.showToast) window.showToast({ message: message, type: type, position: toastPosition });
    }

    // --- Money formatting (mirrors Shopify's `money` filter, fed by shop.money_format) ---
    function formatWithDelimiters(cents, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(cents) || cents == null) return '0';
      var number = (cents / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }

    function money(cents) {
      var format = moneyFormat || '${{amount}}';
      var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var placeholder = match ? match[1] : 'amount';
      var value;
      switch (placeholder) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', '');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }
      // Strip any HTML the money format may carry so it's safe as textContent.
      return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
    }

    var imageToken = 0; // guards against out-of-order stage-image loads

    // Swap the stage image, showing a spinner until it has actually loaded.
    // Product JSON usually arrives long before the image bytes do.
    function setStageImage(src) {
      var main = els.mediaMain;
      if (!main) {
        els.image.src = src;
        return;
      }

      var token = ++imageToken;
      main.classList.add('is-image-loading');

      function done() {
        if (token !== imageToken) return; // a newer image superseded this one
        main.classList.remove('is-image-loading');
      }

      els.image.onload = done;
      els.image.onerror = done;
      els.image.src = src;
      // A cached image can already be complete here; `load` may never fire.
      if (els.image.complete && els.image.naturalWidth) done();
    }

    // Ask the Shopify CDN for a right-sized image without breaking existing params.
    function sizeImg(url, w) {
      if (!url) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function optionNamesOf(product) {
      return (product.options || []).map(function (o) {
        return typeof o === 'string' ? o : o.name;
      });
    }

    function fetchProduct(handle) {
      if (cache[handle]) return Promise.resolve(cache[handle]);
      return fetch(cartRoot + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Could not load product');
          return res.json();
        })
        .then(function (product) {
          cache[handle] = product;
          return product;
        });
    }

    // `silent` skips the success toast and the cart-drawer event — used by Buy
    // now, which navigates to checkout and must not pop the drawer on the way out.
    function addVariantToCart(variantId, properties, onDone, silent) {
      var payload = { id: variantId, quantity: 1 };
      if (properties && Object.keys(properties).length) payload.properties = properties;
      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'Could not add to cart');
          if (!silent) {
            toast('Item added to your cart.', 'success');
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { open: true } }));
          }
          if (onDone) onDone(true);
        })
        .catch(function (err) {
          toast(err.message, 'error');
          if (onDone) onDone(false);
        });
    }

    // Line-item properties for the current selection. PDP parity: the uploaded
    // custom-colour image rides along while its option value still contains "custom".
    function selectedProperties() {
      var properties = {};
      if (
        customImage.url &&
        customImage.optionIndex > -1 &&
        isCustomValue(state.selected[customImage.optionIndex])
      ) {
        properties['added_url_image'] = customImage.url;
      }
      return properties;
    }

    // --- Variant resolution + live price ---
    function findVariant(product, selected) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] !== selected[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function updateSelection() {
      var variant = findVariant(state.product, state.selected);
      state.variant = variant;
      if (variant) {
        els.price.textContent = money(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          els.compare.textContent = money(variant.compare_at_price);
          els.compare.hidden = false;
        } else {
          els.compare.hidden = true;
        }
        els.add.disabled = !variant.available;
        els.addText.textContent = variant.available ? addLabel : 'Sold out';
      } else {
        els.price.textContent = '';
        els.compare.hidden = true;
        els.add.disabled = true;
        els.addText.textContent = 'Unavailable';
      }
      syncBuyButton();
    }

    // Buy now follows Add to cart exactly: it must never check out a variant the
    // shopper can't add. Never re-enable while a checkout redirect is in flight.
    function syncBuyButton() {
      if (!els.buy) return;
      if (els.buy.classList.contains('is-loading')) return;
      els.buy.disabled = els.add.disabled;
    }

    // --- Option classification (mirrors the PDP variant picker) ---
    function classifyOption(name) {
      var n = String(name || '').toLowerCase();
      var isSurface = n.indexOf('surface') > -1;
      var isSize = n.indexOf('size') > -1;
      var isColor = n.indexOf('color') > -1 || n.indexOf('finish') > -1;
      return { isColorOrFinish: isColor && !isSurface, isSize: isSize };
    }

    function isCustomValue(val) {
      return String(val == null ? '' : val)
        .trim()
        .toLowerCase()
        .indexOf('custom') > -1;
    }

    // Turn a "Custom" colour/finish pill into a thumbnail of the uploaded
    // reference image. The pill then doubles as a link: clicking it while it is
    // the active choice opens the full image in a new tab.
    function setPillImage(pill, url, optionName) {
      if (!pill || !url) return;
      pill.innerHTML = '';
      pill.classList.add('sp-quick__pill--image');
      var img = document.createElement('img');
      img.src = url;
      img.alt = '';
      img.loading = 'lazy';
      pill.appendChild(img);
      var label = 'Your custom ' + String(optionName || 'color').toLowerCase() + ' reference image — open in a new tab';
      pill.setAttribute('aria-label', label);
      pill.setAttribute('title', label);
    }

    function openImageTab(url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }

    // --- Custom colour upload: guide → device picker → upload ---
    function closeColorGuide() {
      hideSubDialog(guide, guideTimer);
      pendingGuideContinue = null;
      // Backing out of the guide abandons the pending "Custom" selection, so it
      // is never committed (no dangling selected pill without an image).
      pendingColorCommit = null;
    }

    function openColorGuide(optionIndex, onContinue, onCommit) {
      customImage.optionIndex = optionIndex;
      pendingColorCommit = onCommit || null;
      // No popup in the DOM → open the file dialog directly (keeps the gesture).
      if (!guide) {
        if (onContinue) onContinue();
        return;
      }
      pendingGuideContinue = onContinue;
      showSubDialog(guide, guideTimer);
      var btn = guide.querySelector('[data-sp-color-guide-continue]');
      if (btn) btn.focus();
    }

    function uploadColorFile(file) {
      if (file.size > MAX_UPLOAD_BYTES) {
        toast('Image exceeds 10MB limit.', 'error');
        return;
      }
      toast('Uploading…', 'info');

      var api = window.WrydecoApi;
      var uploadPromise =
        api && typeof api.uploadCustomColorImage === 'function'
          ? api.uploadCustomColorImage(file)
          : (function () {
              var fd = new FormData();
              fd.append('image', file);
              return fetch('https://admin.wrydeco.com/api/upload-image', { method: 'POST', body: fd }).then(function (
                res
              ) {
                return res
                  .json()
                  .catch(function () {
                    return {};
                  })
                  .then(function (data) {
                    return { ok: res.ok, data: data };
                  });
              });
            })();

      uploadPromise
        .then(function (r) {
          if (r && r.ok && r.data && r.data.image_url) {
            customImage.url = r.data.image_url;
            // Only now that a reference image exists do we commit the "Custom"
            // selection (select the pill + update price/variant).
            if (pendingColorCommit) {
              pendingColorCommit();
              pendingColorCommit = null;
            }
            toast('Custom color uploaded.', 'success');
          } else {
            var detail =
              (r && r.data && (r.data.detail || r.data.message)) || 'Upload failed. Please try again.';
            toast(typeof detail === 'string' ? detail : 'Upload failed. Please try again.', 'error');
          }
        })
        .catch(function () {
          toast('Upload failed. Please try again.', 'error');
        })
        .finally(function () {
          if (fileInput) fileInput.value = ''; // allow re-picking the same file
        });
    }

    // --- Custom size request form ---
    function sizeEl(sel) {
      return sizePopup ? sizePopup.querySelector(sel) : null;
    }
    function fieldInput(field) {
      return sizeEl(field === 'note' ? '[data-sp-size-note]' : '[data-sp-size-contact]');
    }
    function setSizeError(field, message) {
      var input = fieldInput(field);
      var el = sizeEl('[data-sp-size-error="' + field + '"]');
      if (input) input.setAttribute('aria-invalid', 'true');
      if (el) {
        el.textContent = message;
        el.hidden = false;
      }
    }
    function clearSizeError(field) {
      var input = fieldInput(field);
      var el = sizeEl('[data-sp-size-error="' + field + '"]');
      if (input) input.removeAttribute('aria-invalid');
      if (el) {
        el.textContent = '';
        el.hidden = true;
      }
    }
    function clearSizeErrors() {
      clearSizeError('note');
      clearSizeError('contact');
    }
    function openSizePopup() {
      if (!sizePopup) return;
      clearSizeErrors();
      showSubDialog(sizePopup, sizeTimer);
      var ta = sizeEl('[data-sp-size-note]');
      if (ta) ta.focus();
    }
    function closeSizePopup() {
      hideSubDialog(sizePopup, sizeTimer);
    }
    function isValidContact(value) {
      var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (EMAIL_RE.test(value)) return true;
      var digits = value.replace(/\D/g, '');
      return digits.length >= 7 && digits.length <= 15 && /^[+()\d\s.-]+$/.test(value);
    }
    function submitSizeRequest() {
      if (!sizePopup || !state || !state.product) return;

      var ta = sizeEl('[data-sp-size-note]');
      var contactEl = sizeEl('[data-sp-size-contact]');
      var submitBtn = sizeEl('[data-sp-size-submit]');
      var submitLabel = sizeEl('[data-sp-size-submit-label]');
      var note = ta ? ta.value.trim() : '';
      var contactValue = contactEl ? contactEl.value.trim() : '';

      clearSizeErrors();
      var firstInvalid = null;
      if (!note) {
        setSizeError('note', 'Please describe the size you want.');
        firstInvalid = firstInvalid || ta;
      } else if (note.length < 5) {
        setSizeError('note', 'Please add a little more detail (at least 5 characters).');
        firstInvalid = firstInvalid || ta;
      }
      if (!contactValue) {
        setSizeError('contact', 'An email or phone number is required.');
        firstInvalid = firstInvalid || contactEl;
      } else if (!isValidContact(contactValue)) {
        setSizeError('contact', 'Enter a valid email or phone number.');
        firstInvalid = firstInvalid || contactEl;
      }
      if (firstInvalid) {
        if (firstInvalid.focus) firstInvalid.focus();
        return;
      }

      var fd = new FormData();
      fd.append('product_id', String(state.product.id || ''));
      fd.append('product_handle', state.product.handle || '');
      fd.append('product_name', state.product.title || '');
      fd.append('custom_size_description', note);
      fd.append('customer_contact', contactValue);

      if (submitBtn) submitBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Sending…';

      var api = window.WrydecoApi;
      var requestPromise =
        api && typeof api.submitCustomSizeRequest === 'function'
          ? api.submitCustomSizeRequest(fd)
          : fetch('https://admin.wrydeco.com/api/custom-size-requests', { method: 'POST', body: fd }).then(function (
              response
            ) {
              return response
                .json()
                .catch(function () {
                  return null;
                })
                .then(function (data) {
                  return { ok: response.ok, status: response.status, data: data };
                });
            });

      requestPromise
        .then(function (response) {
          if (response && response.ok) {
            toast("Thank you — we've received your request and will contact you shortly.", 'success');
            if (ta) ta.value = '';
            if (contactEl) contactEl.value = '';
            clearSizeErrors();
            closeSizePopup();
            return;
          }
          var data = response && response.data;
          var mapped = false;
          if (data && Array.isArray(data.errors)) {
            data.errors.forEach(function (err) {
              if (err.field === 'custom_size_description') {
                setSizeError('note', err.message);
                mapped = true;
              } else if (err.field === 'customer_contact') {
                setSizeError('contact', err.message);
                mapped = true;
              }
            });
          }
          if (!mapped) toast((data && data.message) || 'Something went wrong. Please try again.', 'error');
        })
        .catch(function () {
          toast('Something went wrong. Please try again.', 'error');
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
          if (submitLabel) submitLabel.textContent = 'Submit request';
        });
    }

    function renderOptions() {
      els.options.innerHTML = '';
      var product = state.product;
      var names = state.optionNames;
      var isSingleDefault = product.variants.length === 1 && names.length === 1 && names[0] === 'Title';
      if (isSingleDefault) return;

      names.forEach(function (optName, oi) {
        var group = document.createElement('div');
        group.className = 'sp-quick__option';

        var label = document.createElement('span');
        label.className = 'sp-quick__option-label';
        label.textContent = optName;
        group.appendChild(label);

        var pills = document.createElement('div');
        pills.className = 'sp-quick__pills';

        var cls = classifyOption(optName);

        var values = [];
        product.variants.forEach(function (v) {
          if (values.indexOf(v.options[oi]) === -1) values.push(v.options[oi]);
        });

        values.forEach(function (val) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'sp-quick__pill';
          pill.textContent = val;
          var custom = isCustomValue(val);
          if (state.selected[oi] === val) pill.setAttribute('aria-pressed', 'true');
          // An image uploaded earlier in this session survives a re-render.
          if (custom && cls.isColorOrFinish && customImage.url && customImage.optionIndex === oi) {
            setPillImage(pill, customImage.url, optName);
          }
          function commitSelection() {
            state.selected[oi] = val;
            Array.prototype.forEach.call(pills.children, function (c) {
              c.removeAttribute('aria-pressed');
            });
            pill.setAttribute('aria-pressed', 'true');
            updateSelection();
          }

          pill.addEventListener('click', function () {
            // Size "Custom": open the request form. It is a lead, not a purchase,
            // so it never becomes the selected variant.
            if (custom && cls.isSize) {
              openSizePopup();
              return;
            }

            // Colour / Wood Finish "Custom": don't select the pill yet. The
            // selection is committed only after a reference image is actually
            // uploaded (guide → device picker → upload). Backing out of the
            // guide therefore leaves the previous choice untouched.
            if (custom && cls.isColorOrFinish) {
              // Already uploaded: the pill now shows the reference image. Clicking
              // it while it is the active choice opens that image in a new tab;
              // clicking it after switching away simply re-selects it.
              if (customImage.url && customImage.optionIndex === oi) {
                if (state.selected[oi] === val) openImageTab(customImage.url);
                else commitSelection();
                return;
              }

              openColorGuide(
                oi,
                function () {
                  if (fileInput) fileInput.click();
                },
                function () {
                  setPillImage(pill, customImage.url, optName);
                  commitSelection();
                }
              );
              return;
            }

            // Normal selection.
            commitSelection();
          });
          pills.appendChild(pill);
        });

        group.appendChild(pills);
        els.options.appendChild(group);
      });
    }

    // --- Focus trap helpers ---
    function getFocusable() {
      var panel = modal.querySelector('.sp-quick__panel');
      if (!panel) return [];
      var nodes = panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      return Array.prototype.filter.call(nodes, function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
    }

    function openModal(loading) {
      var panel = modal.querySelector('.sp-quick__panel');
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('sp-quick-open');
      if (loading) {
        panel.classList.add('is-loading');
        els.loading.hidden = false;
        els.media.hidden = true;
        els.body.hidden = true;
      }
      window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
    }

    function closeModal() {
      closeColorGuide();
      closeSizePopup();
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sp-quick-open');
      window.setTimeout(function () {
        modal.hidden = true;
      }, 240);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function populate(product) {
      var panel = modal.querySelector('.sp-quick__panel');
      panel.classList.remove('is-loading');
      els.loading.hidden = true;
      els.body.hidden = false;
      if (els.baseInfo) els.baseInfo.scrollTop = 0;

      var names = optionNamesOf(product);
      var initial = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) {
          initial = product.variants[i];
          break;
        }
      }
      if (!initial) initial = product.variants[0];
      state = { product: product, selected: initial.options.slice(), variant: initial, optionNames: names };

      // Fresh product → drop any custom-colour image / open sub-dialogs from a
      // previous product, and clear a Buy now spinner left over from a failed run.
      customImage = { url: '', optionIndex: -1 };
      if (els.buy) {
        els.buy.classList.remove('is-loading');
        els.buy.removeAttribute('aria-busy');
        if (els.buyText) els.buyText.textContent = buyLabel;
      }
      closeColorGuide();
      closeSizePopup();

      els.title.textContent = product.title;

      // Gallery: one large image + a row of thumbnails.
      var raw =
        product.images && product.images.length
          ? product.images
          : product.featured_image
          ? [product.featured_image]
          : [];
      var gallery = raw.map(function (src) {
        return sizeImg(src, 800);
      });
      els.thumbs.innerHTML = '';
      if (gallery.length) {
        els.image.alt = product.title;
        els.media.hidden = false;
        setStageImage(gallery[0]);
      } else {
        els.media.hidden = true;
      }

      if (gallery.length > 1) {
        gallery.forEach(function (src, idx) {
          var thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'sp-quick__thumb';
          thumb.setAttribute('aria-label', 'View image ' + (idx + 1));
          if (idx === 0) thumb.setAttribute('aria-current', 'true');
          var timg = document.createElement('img');
          timg.src = src;
          timg.alt = '';
          timg.loading = 'lazy';
          thumb.appendChild(timg);
          thumb.addEventListener('click', function () {
            setStageImage(src);
            Array.prototype.forEach.call(els.thumbs.children, function (c) {
              c.removeAttribute('aria-current');
            });
            thumb.setAttribute('aria-current', 'true');
          });
          els.thumbs.appendChild(thumb);
        });
        els.thumbs.hidden = false;
      } else {
        els.thumbs.hidden = true;
      }

      els.details.setAttribute('href', product.url || '#');

      renderOptions();
      updateSelection();

      var firstPill = els.options.querySelector('.sp-quick__pill');
      (firstPill || els.add).focus();
    }

    function openFor(trigger) {
      var handle = trigger.getAttribute('data-product-handle');
      if (!handle) {
        var host = trigger.closest('[data-product-handle]');
        handle = host && host.getAttribute('data-product-handle');
      }
      if (!handle) return;

      lastFocused = trigger;
      var reqId = ++requestId;
      openModal(true);

      fetchProduct(handle)
        .then(function (product) {
          if (reqId !== requestId) return; // a newer open superseded this one
          if (!product.variants || !product.variants.length) {
            closeModal();
            return;
          }
          populate(product);
        })
        .catch(function (err) {
          if (reqId !== requestId) return;
          closeModal();
          toast((err && err.message) || 'Could not load product', 'error');
        });
    }

    // --- Global (document-level) listeners: one set, via event delegation ---
    function onDocClick(e) {
      if (!modal) return;
      var trigger = e.target.closest('[data-quick-customize]');
      if (!trigger) return;
      e.preventDefault();
      openFor(trigger);
    }

    function onKeydown(e) {
      if (!modal || modal.hidden) return;
      if (e.key === 'Escape') {
        // Close an open sub-dialog first; only then the main dialog.
        if (guide && !guide.hidden) {
          closeColorGuide();
          return;
        }
        if (sizePopup && !sizePopup.hidden) {
          closeSizePopup();
          return;
        }
        closeModal();
        return;
      }
      if (e.key !== 'Tab') return;
      // While a sub-dialog is open, let it own the tab order.
      if ((guide && !guide.hidden) || (sizePopup && !sizePopup.hidden)) return;

      var focusable = getFocusable();
      if (!focusable.length) {
        e.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var panel = modal.querySelector('.sp-quick__panel');
      var active = document.activeElement;

      if (!panel || !panel.contains(active)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function onAdd() {
      if (!state || !state.variant || els.add.disabled || els.add.classList.contains('is-loading')) return;

      els.add.classList.add('is-loading');
      els.addText.textContent = 'Adding…';
      addVariantToCart(state.variant.id, selectedProperties(), function (ok) {
        els.add.classList.remove('is-loading');
        if (ok) closeModal();
        else updateSelection();
      });
    }

    // Buy now: add the selected variant, then go straight to checkout. Checkout
    // therefore includes whatever else is already in the cart — the note above
    // the button says so. Shopify clears the cart once the order completes, and
    // no theme-side checkout route avoids that (verified: the dynamic checkout
    // button and a separate Storefront API cart both lose it too).
    function onBuy() {
      if (!els.buy) return;
      if (!state || !state.variant || els.buy.disabled || els.buy.classList.contains('is-loading')) return;

      els.buy.classList.add('is-loading');
      els.buy.disabled = true;
      els.buy.setAttribute('aria-busy', 'true');
      if (els.buyText) els.buyText.textContent = 'Processing…';

      function release() {
        els.buy.classList.remove('is-loading');
        els.buy.removeAttribute('aria-busy');
        if (els.buyText) els.buyText.textContent = buyLabel;
        updateSelection();
      }

      var fallback = window.setTimeout(release, 8000);
      window.addEventListener(
        'pagehide',
        function () {
          window.clearTimeout(fallback);
        },
        { once: true }
      );

      addVariantToCart(
        state.variant.id,
        selectedProperties(),
        function (ok) {
          if (!ok) {
            window.clearTimeout(fallback);
            release();
            return;
          }
          window.location.href = cartRoot + 'checkout';
        },
        true
      );
    }

    // Cache the active dialog + its children. De-dupes if rendered more than once.
    function wireModal() {
      var modals = document.querySelectorAll('[data-quick-modal]');
      if (!modals.length) {
        modal = null;
        return;
      }
      // Keep the first, drop any duplicates so ids stay unique.
      for (var i = 1; i < modals.length; i++) {
        if (modals[i].parentNode) modals[i].parentNode.removeChild(modals[i]);
      }
      modal = modals[0];
      els = {
        title: modal.querySelector('[data-quick-title]'),
        media: modal.querySelector('[data-quick-media]'),
        mediaMain: modal.querySelector('[data-quick-media-main]'),
        image: modal.querySelector('[data-quick-image]'),
        thumbs: modal.querySelector('[data-quick-thumbs]'),
        options: modal.querySelector('[data-quick-options]'),
        price: modal.querySelector('[data-quick-price]'),
        compare: modal.querySelector('[data-quick-compare]'),
        add: modal.querySelector('[data-quick-add]'),
        addText: modal.querySelector('[data-quick-add-text]'),
        buy: modal.querySelector('[data-quick-buy]'),
        buyBase: modal.querySelector('[data-quick-buy-base]'),
        buyText: modal.querySelector('[data-quick-buy-text]'),
        details: modal.querySelector('[data-quick-details]'),
        loading: modal.querySelector('[data-quick-loading]'),
        body: modal.querySelector('[data-quick-body]'),
        baseInfo: modal.querySelector('.sp-quick__base-info'),
      };
      moneyFormat = modal.getAttribute('data-money-format') || '${{amount}}';
      toastPosition = modal.getAttribute('data-toast-position') || 'bottom-left';

      if (modal.dataset.wired !== 'true') {
        modal.dataset.wired = 'true';
        addLabel = els.addText.textContent.trim();
        if (els.buyText) buyLabel = els.buyText.textContent.trim();
        modal.querySelectorAll('[data-quick-close]').forEach(function (el) {
          el.addEventListener('click', closeModal);
        });
        els.add.addEventListener('click', onAdd);
        if (els.buy) els.buy.addEventListener('click', onBuy);
      }

      // Cache the sub-dialogs (rendered once alongside the modal), de-duping any
      // extras if the snippet was rendered more than once.
      function firstDedup(sel) {
        var nodes = document.querySelectorAll(sel);
        for (var i = 1; i < nodes.length; i++) {
          if (nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
        }
        return nodes[0] || null;
      }
      guide = firstDedup('[data-sp-color-guide]');
      fileInput = firstDedup('[data-sp-color-file]');
      sizePopup = firstDedup('[data-sp-size-popup]');

      if (guide && guide.dataset.wired !== 'true') {
        guide.dataset.wired = 'true';
        guide.querySelectorAll('[data-sp-color-guide-close]').forEach(function (el) {
          el.addEventListener('click', closeColorGuide);
        });
        var cont = guide.querySelector('[data-sp-color-guide-continue]');
        if (cont) {
          cont.addEventListener('click', function () {
            // Capture before hiding; running it here keeps the user gesture so
            // the browser allows the file dialog to open. Only hide the guide —
            // keep `pendingColorCommit` alive so a successful upload can commit
            // the "Custom" selection (closeColorGuide would clear it).
            var next = pendingGuideContinue;
            hideSubDialog(guide, guideTimer);
            pendingGuideContinue = null;
            if (next) next();
          });
        }
      }

      if (fileInput && fileInput.dataset.wired !== 'true') {
        fileInput.dataset.wired = 'true';
        fileInput.addEventListener('change', function () {
          var f = fileInput.files && fileInput.files[0];
          if (f) uploadColorFile(f);
        });
      }

      if (sizePopup && sizePopup.dataset.wired !== 'true') {
        sizePopup.dataset.wired = 'true';
        sizePopup.querySelectorAll('[data-sp-size-close]').forEach(function (el) {
          el.addEventListener('click', closeSizePopup);
        });
        var sub = sizePopup.querySelector('[data-sp-size-submit]');
        if (sub) sub.addEventListener('click', submitSizeRequest);
        var noteEl = sizePopup.querySelector('[data-sp-size-note]');
        var contactEl = sizePopup.querySelector('[data-sp-size-contact]');
        if (noteEl)
          noteEl.addEventListener('input', function () {
            clearSizeError('note');
          });
        if (contactEl)
          contactEl.addEventListener('input', function () {
            clearSizeError('contact');
          });
      }
    }

    function init() {
      wireModal();
      if (!bound) {
        bound = true;
        document.addEventListener('click', onDocClick);
        document.addEventListener('keydown', onKeydown);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Theme editor: a re-rendered section may ship a fresh dialog — re-cache it.
    document.addEventListener('shopify:section:load', wireModal);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const btn = document.getElementById('scrollToTopBtn');
    if (!btn) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 300) {
        btn.classList.add('is-visible');
        btn.removeAttribute('aria-hidden');
        btn.removeAttribute('tabindex');
      } else {
        btn.classList.remove('is-visible');
        btn.setAttribute('aria-hidden', 'true');
        btn.setAttribute('tabindex', '-1');
      }
    });

    btn.addEventListener('click', () => {
      window.scrollTo({
        top: 100,
        behavior: 'instant',
      });

      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }, 50);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shop-pay-installments"] && !Shopify.designMode) return;
  try {
    (function () {
    function syncShopPayInstallmentsVariant(event) {
      var variantId = event && event.detail ? event.detail.variantId : null;
      if (!variantId) return;

      document.querySelectorAll('[data-shop-pay-installments-variant-id]').forEach(function (input) {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    document.addEventListener('variant:change', syncShopPayInstallmentsVariant);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["welcome-video-component"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const formatTime = (seconds, paddedMinutes = false) => {
      if (!Number.isFinite(seconds) || seconds < 0) return paddedMinutes ? '00:00' : '0:00';

      const totalSeconds = Math.floor(seconds);
      const minutes = Math.floor(totalSeconds / 60);
      const remainingSeconds = totalSeconds % 60;
      const minuteText = paddedMinutes ? String(minutes).padStart(2, '0') : String(minutes);

      return `${minuteText}:${String(remainingSeconds).padStart(2, '0')}`;
    };

    const setRangeFill = (range, percent) => {
      if (!range) return;
      range.style.setProperty('--range-fill', `${Math.max(0, Math.min(100, percent))}%`);
    };

    document.querySelectorAll('.welcome-video').forEach((section) => {
      const frame = section.querySelector('.welcome-video__frame');
      const video = section.querySelector('[data-welcome-video-media]');
      const toggleButtons = section.querySelectorAll('[data-welcome-video-toggle]');
      const progressRange = section.querySelector('[data-welcome-video-progress]');
      const currentTime = section.querySelector('[data-welcome-video-current]');
      const totalTime = section.querySelector('[data-welcome-video-total]');
      const muteButton = section.querySelector('[data-welcome-video-mute]');
      const volumeRange = section.querySelector('[data-welcome-video-volume]');
      const settingsButton = section.querySelector('[data-welcome-video-settings]');
      const settingsPanel = section.querySelector('[data-welcome-video-settings-panel]');
      const rateButtons = section.querySelectorAll('[data-welcome-video-rate]');
      const fullscreenButton = section.querySelector('[data-welcome-video-fullscreen]');
      let hideControlsTimer;

      if (!frame || !video || section.dataset.welcomeVideoInit === 'true') return;
      section.dataset.welcomeVideoInit = 'true';

      const isCompactViewport = () => window.matchMedia('(max-width: 1024px)').matches;

      const clearNativePoster = () => {
        if (!video.hasAttribute('poster')) return;
        video.dataset.welcomeVideoPoster = video.getAttribute('poster');
        video.removeAttribute('poster');
      };

      const restoreNativePoster = () => {
        if (video.hasAttribute('poster') || !video.dataset.welcomeVideoPoster) return;
        video.setAttribute('poster', video.dataset.welcomeVideoPoster);
      };

      const shouldKeepControlsHidden = () =>
        section.dataset.mobileCenterPlayback === 'true' &&
        isCompactViewport();

      const showControls = () => {
        window.clearTimeout(hideControlsTimer);
        if (shouldKeepControlsHidden()) {
          section.classList.add('are-controls-hidden');
          return;
        }
        section.classList.remove('are-controls-hidden');
      };

      const hideControls = (force = false) => {
        if (!force) {
          if (settingsPanel && !settingsPanel.hidden) return;
          if (section.matches(':focus-within')) return;
        }

        section.classList.add('are-controls-hidden');
      };

      const queueControlsHide = () => {
        window.clearTimeout(hideControlsTimer);
        hideControlsTimer = window.setTimeout(hideControls, 500);
      };

      const updatePlayState = () => {
        const isPlaying = !video.paused && !video.ended;
        section.classList.toggle('is-playing', isPlaying);
        if (!isPlaying) {
          delete section.dataset.mobileCenterPlayback;
        }

        toggleButtons.forEach((button) => {
          button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
        });
      };

      const updateMutedState = () => {
        const isMuted = video.muted || video.volume === 0;
        section.classList.toggle('is-muted', isMuted);

        if (muteButton) {
          muteButton.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
        }

        if (volumeRange) {
          volumeRange.value = isMuted ? 0 : video.volume;
          setRangeFill(volumeRange, Number(volumeRange.value) * 100);
        }
      };

      const updateDuration = () => {
        if (totalTime) totalTime.textContent = formatTime(video.duration);
      };

      const updateProgress = () => {
        const duration = video.duration;
        const progress = Number.isFinite(duration) && duration > 0 ? (video.currentTime / duration) * 100 : 0;

        if (currentTime) currentTime.textContent = formatTime(video.currentTime);
        if (progressRange && document.activeElement !== progressRange) {
          progressRange.value = Math.round(progress * 10);
        }
        setRangeFill(progressRange, progress);
      };

      const togglePlayback = async (event, forceHiddenPlayback = false) => {
        const toggleButton = event ? event.currentTarget : null;
        const isPlayToggleButton =
          toggleButton &&
          (toggleButton.classList.contains('welcome-video__center-play') || toggleButton.querySelector('.welcome-video__icon--play'));
        const shouldStartHiddenPlayback =
          isCompactViewport() &&
          (forceHiddenPlayback || isPlayToggleButton) &&
          (video.paused || video.ended);

        if (video.paused || video.ended) {
          try {
            if (shouldStartHiddenPlayback) {
              section.dataset.mobileCenterPlayback = 'true';
              section.classList.add('are-controls-hidden');
              if (toggleButton) {
                toggleButton.blur();
              }
            }
            clearNativePoster();
            const playPromise = video.play();
            await playPromise;
          } catch (error) {
            delete section.dataset.mobileCenterPlayback;
            section.classList.remove('is-playing');
            restoreNativePoster();
            if (shouldStartHiddenPlayback) {
              showControls();
            }
          }
        } else {
          video.pause();
        }

        updatePlayState();
      };

      toggleButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          if (isCompactViewport()) {
            event.stopPropagation();
          }

          togglePlayback(event);
        });
      });

      frame.addEventListener('mouseenter', showControls);
      frame.addEventListener('mousemove', showControls);
      frame.addEventListener('mouseleave', queueControlsHide);
      frame.addEventListener('focusin', showControls);
      frame.addEventListener('focusout', queueControlsHide);

      frame.addEventListener('click', (event) => {
        if (event.target.closest('[data-welcome-video-controls]')) return;
        if (event.target.closest('[data-welcome-video-toggle]')) return;
        if (event.target.closest('[data-welcome-video-settings-panel]')) return;
        const shouldStartHiddenPlayback = isCompactViewport() && (video.paused || video.ended);
        if (!shouldStartHiddenPlayback) {
          showControls();
        }
        togglePlayback(null, shouldStartHiddenPlayback);
      });

      document.addEventListener('click', (event) => {
        if (frame.contains(event.target)) {
          showControls();
          return;
        }

        hideControls();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          hideControls();
        }
      });

      video.addEventListener('loadedmetadata', () => {
        updateDuration();
        updateProgress();
      });
      video.addEventListener('durationchange', updateDuration);
      video.addEventListener('timeupdate', updateProgress);
      video.addEventListener('play', () => {
        clearNativePoster();
        updatePlayState();
      });
      video.addEventListener('playing', clearNativePoster);
      video.addEventListener('pause', updatePlayState);
      video.addEventListener('ended', () => {
        updatePlayState();
        updateProgress();
      });

      if (progressRange) {
        progressRange.addEventListener('input', () => {
          const duration = video.duration;
          const progress = Number(progressRange.value) / 1000;

          if (Number.isFinite(duration) && duration > 0) {
            video.currentTime = duration * progress;
          }

          setRangeFill(progressRange, progress * 100);
        });
      }

      if (muteButton) {
        muteButton.addEventListener('click', () => {
          video.muted = !(video.muted || video.volume === 0);
          if (!video.muted && video.volume === 0) {
            video.volume = 0.8;
          }
          updateMutedState();
        });
      }

      if (volumeRange) {
        volumeRange.addEventListener('input', () => {
          video.volume = Number(volumeRange.value);
          video.muted = video.volume === 0;
          updateMutedState();
        });
      }

      if (settingsButton && settingsPanel) {
        settingsButton.addEventListener('click', () => {
          const shouldOpen = settingsPanel.hidden;
          settingsPanel.hidden = !shouldOpen;
          settingsButton.setAttribute('aria-expanded', String(shouldOpen));
          showControls();
        });
      }

      rateButtons.forEach((button) => {
        button.addEventListener('click', () => {
          video.playbackRate = Number(button.dataset.welcomeVideoRate);
          rateButtons.forEach((rateButton) => {
            rateButton.setAttribute('aria-current', String(rateButton === button));
          });
          if (settingsPanel && settingsButton) {
            settingsPanel.hidden = true;
            settingsButton.setAttribute('aria-expanded', 'false');
          }
        });
      });

      if (fullscreenButton) {
        fullscreenButton.addEventListener('click', async () => {
          try {
            if (document.fullscreenElement) {
              await document.exitFullscreen();
            } else if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            } else if (frame.requestFullscreen) {
              await frame.requestFullscreen();
            } else if (frame.webkitRequestFullscreen) {
              frame.webkitRequestFullscreen();
            } else if (video.webkitEnterFullscreen) {
              video.webkitEnterFullscreen();
            }
          } catch (error) {
            section.classList.remove('is-fullscreen');
          }
        });
      }

      const updateFullscreenState = () => {
        const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
        const isFullscreen = fullscreenElement === frame || fullscreenElement === video;
        section.classList.toggle('is-fullscreen', isFullscreen);

        if (fullscreenButton) {
          fullscreenButton.setAttribute('aria-label', isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen');
        }
      };

      document.addEventListener('fullscreenchange', updateFullscreenState);
      document.addEventListener('webkitfullscreenchange', updateFullscreenState);
      video.addEventListener('webkitbeginfullscreen', updateFullscreenState);
      video.addEventListener('webkitendfullscreen', updateFullscreenState);

      setRangeFill(progressRange, 0);
      setRangeFill(volumeRange, 100);
      updateDuration();
      updateProgress();
      updateMutedState();
      updatePlayState();
      hideControls(true);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
